import { NgModule } from '@angular/core';
import {PersonaCardComponent} from "./card/card.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {} from "@angular/common/http";
import { RouterModule } from '@angular/router';
import { GLMMaterialDesignModule } from '../_components/material-design/material-design.module';

@NgModule({
    imports: [
        CommonModule,
        // HttpClientModule,
        ReactiveFormsModule,
        GLMMaterialDesignModule,
        RouterModule
    ],
    exports: [
        PersonaCardComponent
    ],
    declarations: [
        PersonaCardComponent
    ],
    providers: [],
})
export class UserModule {
}
